export default __webpack_public_path__ + "img/main.blue.0f4e947b.png";